/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * IRR component information
 */
export interface IrrComponentInfo { 
    /**
     * Version of the IRR image
     */
    version?: string;
    /**
     * Cloud provider where the IRR is deployed
     */
    cloudProvider?: string;
    /**
     * Availability zone of the IRR
     */
    availabilityZone?: string;
    /**
     * Organization identifier
     */
    orgId?: string;
    /**
     * Selected EDR type for the IRR
     */
    selectedEdr?: string;
}

